import { createAction, props } from '@ngrx/store';
import { LoginRequest } from '../../login/models/login.request';
import { User } from '../../users/models/user';
import { Role } from '../../shared/models/role';

export const login = createAction(
  '[Login] Login',
  props<{ credentials: LoginRequest }>()
);

export const loginSuccess = createAction(
  '[Login] Login Success',
  props<{ access_token: string }>()
);

export const loginError = createAction(
  '[Login] Login Error',
  props<{ error: any }>()
);

export const logout = createAction('[Login] Logout');

export const findUser = createAction(
  '[Login] Find User',
  props<{ id: string }>()
);

export const findUserSuccess = createAction(
  '[Login] Find User Success',
  props<{ user: User }>()
);

export const setCurrentRole = createAction(
  '[Login] set current role',
  props<{ role: Role }>()
);

export const goHome = createAction('[Login] Go Home');
